/**
 * Slider text
 */
class Mokolove_SliderText {
    constructor () {
        if ($('.slider-images-text-wrapper').length) {
            let wrappers = $('.slider-images-text-wrapper');

            for (let i = 0; i < wrappers.length; i++) {
                this.init(wrappers.eq(i));
            }
        }
    }

    init (wrapper) {
        wrapper.find('.prev').addClass('is-hidden');

        wrapper.find('.prev').on('click', (e) => {
            e.preventDefault();
            let current = parseInt(wrapper.find('.slider-images').attr('data-current'), 10);
            let count = parseInt(wrapper.find('.slider-images').attr('data-count'), 10);

            if (current > 1) {
                current--;
            }

            if (current === 1) {
                wrapper.find('.prev').addClass('is-hidden');
            }

            if (current < count) {
                wrapper.find('.next').removeClass('is-hidden');
            }

            wrapper.find('.slider-images').attr('data-current', current);
        });

        wrapper.find('.next').on('click', (e) => {
            e.preventDefault();
            let current = parseInt(wrapper.find('.slider-images').attr('data-current'), 10);
            let count = parseInt(wrapper.find('.slider-images').attr('data-count'), 10);

            if (current < count) {
                current++;
            }

            if (current === count) {
                wrapper.find('.next').addClass('is-hidden');
            }

            if (current > 1) {
                wrapper.find('.prev').removeClass('is-hidden');
            }

            wrapper.find('.slider-images').attr('data-current', current);
        });

        let swipeEffect = new Hammer(wrapper[0]);

        swipeEffect.on('swipe', ev => {
            if (ev.type === 'swipe' && ev.direction === 2) {
                wrapper.find('.next').trigger('click');
            }

            if (ev.type === 'swipe' && ev.direction === 4) {
                wrapper.find('.prev').trigger('click');
            }
        });
    }
}
